module.exports = __webpack_public_path__ + "7b302c2aef0d948079abf8a5fb77fe33.work3.svg";


//////////////////
// WEBPACK FOOTER
// ./containers/workWithUsPage/assets/work3.svg
// module id = 2Pcb
// module chunks = 0